import { Api_Signin, Api_Signup } from "../../../constants/SubApi.js";
export const Api_Base = (() => {
	const result = document.baseURI || "https://shakati.net/";
	return result.endsWith("/") ? result : result + "/";
})();

class ApiService {
	constructor() {
		this.base = Api_Base.replace(/\/$/, "");
	}

	_buildUrl(path) {
		const p = path.replace(/^\//, "");
		return `${this.base}/${p}`;
	}

	_getToken() {
		try {
			return localStorage.getItem("token");
		} catch (e) {
			return null;
		}
	}

	async signin(payload) {
		const data = await this.post(Api_Signin, payload);
		if (data && (data.token || data.accessToken)) {
			const t = data.token || data.accessToken;
			try {
				localStorage.setItem("token", t);
			} catch (e) {}
		}
		return data;
	}

	async signup(payload) {
		const data = await this.post(Api_Signup, payload);
		if (data && (data.token || data.accessToken)) {
			const t = data.token || data.accessToken;
			try {
				localStorage.setItem("token", t);
			} catch (e) {}
		}
		return data;
	}

	async request(method, path, body = null, opts = {}) {
		const url = this._buildUrl(path);
		const headers = Object.assign({}, opts.headers || {});

		if (!opts.isForm) {
			headers["Content-Type"] = "application/json";
		}

		const token = this._getToken();
		if (token) headers["Authorization"] = `Bearer ${token}`;

		const res = await fetch(url, {
			method,
			headers,
			body: body != null && !opts.isForm ? JSON.stringify(body) : body,
		});

		const text = await res.text();
		let data = null;

		try {
			data = text ? JSON.parse(text) : null;
		} catch {
			data = text;
		}

		if (data?.error === "messages.error.Accessdenied" || res.status === 403) {
			try {
				localStorage.removeItem("token");
				localStorage.removeItem("architecture");
			} catch (e) {
				console.error(e);
			}
			window.location.reload();
			window.location.replace("/");
			return;
		}

		if (!res.ok) {
			const err = new Error(data?.message || res.statusText || "Request failed");
			err.response = res;
			err.data = data;
			throw err;
		}

		return data;
	}

	get(path, opts) {
		return this.request("GET", path, null, opts);
	}

	post(path, body, opts = {}) {
		return this.request("POST", path, body, opts);
	}

	put(path, body, opts) {
		return this.request("PUT", path, body, opts);
	}

	patch(path, body, opts) {
		return this.request("PATCH", path, body, opts);
	}

	delete(path, body, opts) {
		return this.request("DELETE", path, body, opts);
	}

	async uploadImages(files) {
		const url = this._buildUrl("upload");

		const formData = new FormData();
		files.forEach((file) => {
			formData.append("images", file, file.name);
		});

		const token = this._getToken();

		const res = await fetch(url, {
			method: "POST",
			body: formData,
			headers: {
				Authorization: token ? `Bearer ${token}` : "",
			},
		});

		const data = await res.json();

		if (!res.ok) {
			throw new Error(data?.message || "Upload failed");
		}

		return data.files.map((f) => (f.url.startsWith("http") ? f.url : `${this.base}${f.url}`));
	}
}

const apiService = new ApiService();
export default apiService;
